import "./styles/main.scss";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Login from "./pages/login";
import Sidebar from "./components/sidebar";
import Dashboard from "./pages/dashboard";
import Paystubs from "./pages/paystubs";
import Documents from "./pages/document";
import ManageEmpDetails from "./pages/manageEmployeDetail";
import PaystubsDetails from "./components/paystubsDetail";
import AccountPage from "./pages/account";
import EditEmployeDetail from "./components/edit_profile/editEmployedetail";
import ClockTime from "./pages/clock-time/clockTime";

function AppLayout() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="d-flex">
      {!isLoginPage && <Sidebar />}
      <div className="flex-grow-1 bg-light" style={{ minHeight: "100vh" }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/manage-employee" element={<ManageEmpDetails />} />

          <Route
            path="/manage-employee/edit-employee"
            element={<EditEmployeDetail />}
          />
          <Route path="/clock-time" element={<ClockTime />} />
          <Route path="/paystubs" element={<Paystubs />} />
          <Route
            path="/paystubs/paystubs-detail"
            element={<PaystubsDetails />}
          />
          <Route path="/documents" element={<Documents />} />
          <Route path="/account" element={<AccountPage />} />
        </Routes>
      </div>
    </div>
  );
}

function AppRoutes() {
  return (
    <div className="App">
      <Router>
        <AppLayout />
      </Router>
    </div>
  );
}

export default AppRoutes;
